import React, { useState, useEffect } from 'react';
import {
    Card, CardContent, CardActions, Grid, Typography, TextField, Button, Box, Table, MenuItem, TableBody,
    TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress, Modal, IconButton,
    TablePagination, InputAdornment, Tab, Tabs, Accordion, AccordionSummary, AccordionDetails, FormControlLabel, Checkbox,
    Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions
} from '@mui/material';
import { makeApiRequest } from '../../../utils/api';
import { formatDate } from '../../../helpers/timeHelper';
import EditIcon from '@mui/icons-material/Edit';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AssignmentIcon from '@mui/icons-material/Assignment';
import WarningIcon from '@mui/icons-material/Warning';
import InfoIcon from '@mui/icons-material/Info';
import DeleteIcon from '@mui/icons-material/Delete';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import OverflowTooltip from '../../../helpers/OverflowTooltip';
import GridOnIcon from '@mui/icons-material/GridOn';
import { Search } from '@mui/icons-material';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';


const ALL_ASSESSMENT_COMPONENTS = [
    { generic_name: 'DOMAIN TECHNICAL CONCEPT', default_specific_name: 'Domain Concept' },
    { generic_name: 'DRAFTING', default_specific_name: 'Drafting' },
    { generic_name: 'MODELING', default_specific_name: 'Modeling' },
    { generic_name: 'ATTENDANCE', default_specific_name: 'Attendance' },
    { generic_name: 'PROJECT (DRAFTING + MODELING)', default_specific_name: 'Project' }
];

const AddBatch = () => {
    const [batches, setBatches] = useState([]);
    const [newBatch, setNewBatch] = useState({
        batch_name: '',
        start_date: '',
        end_date: '',
        enrollment: 0,
        location: '',
        status: '',
        course: '',
        course_id: '',
        mode: 'Offline'
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [selectedBatch, setSelectedBatch] = useState(null);
    const [newStatus, setNewStatus] = useState('')
    const [editForm, setEditForm] = useState({
        batch_name: '',
        start_date: '',
        end_date: '',
        location: '',
        status: '',
        course: '',
        course_id: '',
        mode: 'Offline'
    });
    const [courseList, setCourseList] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedLocation, setSelectedLocation] = useState(0);

    const [assessmentModalOpen, setAssessmentModalOpen] = useState(false);
    const [modalBatch, setModalBatch] = useState(null);
    const [modalAssessments, setModalAssessments] = useState([]);
    const [isSavingAssessments, setIsSavingAssessments] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmTitle, setConfirmTitle] = useState('');
    const [confirmMessage, setConfirmMessage] = useState('');
    const [confirmSeverity, setConfirmSeverity] = useState('info');
    const [createBatchAssessments, setCreateBatchAssessments] = useState([]);

    const getAvailableComponents = (currentList) => {
        return ALL_ASSESSMENT_COMPONENTS.filter(comp => 
            !currentList.some(item => item.generic_name === comp.generic_name)
        );
    };

    const token = localStorage.getItem('authToken');
    const control = localStorage.getItem('control');
    const userLocation = localStorage.getItem('userLocation');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [tabValue, setTabValue] = useState(0);
    const [listStatusTab, setListStatusTab] = useState(0); // 0 = Current, 1 = Upcoming, 2 = Completed, 3 = All
    const canManageBatch = control == 1 || control == 4;

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const handleListStatusTabChange = (event, newValue) => {
        setListStatusTab(newValue);
        setPage(0);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const getLocationName = (code) => {
        return code === 1 ? 'Chennai' : code === 2 ? 'Trichy' : 'NA';
    };
    const setFilteredBatches = (data) => {
        const filtered = data.filter(batch => Number(batch.location) === Number(userLocation));
        setBatches(filtered);
    };


    useEffect(() => {
        if (control == 4 && userLocation) {
            let prefix = "";
            if (userLocation === "1") {
                prefix = "CH";
            } else if (userLocation === "2") {
                prefix = "TR";
            }
            setNewBatch(prev => ({ ...prev, location: userLocation, batch_name: `${prefix}-` }));
        }
    }, [userLocation, control]);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            setError(null);
            try {
                const [batchResponse, courseResponse] = await Promise.all([
                    makeApiRequest('post', '/api/listBatches', { token }),
                    makeApiRequest('post', '/api/course/list', { token }),
                ]);

                if (batchResponse.status !== 'success') {
                    throw new Error(batchResponse.message || 'Failed to fetch batches');
                }
                if (courseResponse.status !== 'success') {
                    throw new Error(courseResponse.message || 'Failed to fetch courses');
                }
                const responseData = batchResponse.data;
                if (control == 2 || control == 4) {
                    const filtered = responseData.filter(
                        batch => Number(batch.location) === Number(userLocation)
                    );
                    setBatches(filtered);
                } else {
                    setBatches(responseData);
                }
                setCourseList(courseResponse.data);
            } catch (err) {
                console.error('Error fetching data:', err);
                setError(err.message || 'Error fetching data');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [token]);

    useEffect(() => {
        if (newBatch.course_id) {
            fetchDefaultAssessments(newBatch.course_id);
        } else {
            setCreateBatchAssessments([]);
        }
    }, [newBatch.course_id]);

    const fetchDefaultAssessments = async (courseId) => {
        try {
            const response = await makeApiRequest('POST', '/api/batch/assessments', {
                token,
                batch_id: 0,
                course_id: courseId
            });
            if (response.status === 'success') {
                setCreateBatchAssessments(response.data);
            }
        } catch (err) {
            console.error('Failed to fetch default assessments:', err);
        }
    };

    const openAssessmentModal = async (batch) => {
        setModalBatch(batch);
        setAssessmentModalOpen(true);
        setModalAssessments([]);
        try {
            const response = await makeApiRequest('POST', '/api/batch/assessments', {
                token,
                batch_id: batch.id,
                course_id: batch.course_id
            });
            if (response.status === 'success') {
                setModalAssessments(response.data);
            }
        } catch (err) {
            toast.error('Failed to load assessments');
        }
    };

    const submitAssessmentsUpdate = async () => {
        setConfirmOpen(false);
        setIsSavingAssessments(true);
        try {
            const response = await makeApiRequest('POST', '/api/batch/assessments/update', {
                token,
                batch_id: modalBatch.id,
                assessments: modalAssessments
            });
            if (response.status === 'success') {
                toast.success('Assessment edit request submitted and is pending approval');
                setAssessmentModalOpen(false);
            } else {
                toast.error(response.message || 'Failed to update assessments');
            }
        } catch (err) {
            console.error(err);
            toast.error('Failed to save assessments');
        } finally {
            setIsSavingAssessments(false);
        }
    };

    const handleSaveBatchAssessments = async () => {
        try {
            const studentsResponse = await makeApiRequest('POST', '/api/listStudents', {
                token,
                batch_course_key: `${modalBatch.id}_${modalBatch.course_id}`,
                assessment_name: modalAssessments[0]?.generic_name || ''
            });
            
            let hasGraded = false;
            if (studentsResponse && studentsResponse.data) {
                hasGraded = studentsResponse.data.some(student => 
                    student.assessments?.some(asm => asm.status === 'completed' || Object.values(asm.marks || {}).some(v => v !== null && v !== ''))
                );
            }

            if (hasGraded) {
                setConfirmTitle("Warning");
                setConfirmMessage("Students in this batch are already graded. Disabling an assessment will permanently delete student marks for that assessment. Do you want to submit the edit request?");
                setConfirmSeverity("danger");
                setConfirmOpen(true);
            } else {
                setConfirmTitle("Confirm Action");
                setConfirmMessage("Are you sure you want to request this assessment configuration change?");
                setConfirmSeverity("info");
                setConfirmOpen(true);
            }
        } catch (err) {
            console.error(err);
            toast.error('Failed to validate batch data');
        }
    };

    const handleCreateBatch = async () => {
        if (newBatch.batch_name && newBatch.start_date) {
            try {
                const requestData = {
                    token: token,
                    data: { 
                        ...newBatch,
                        assessments: createBatchAssessments
                    }
                };
                const response = await makeApiRequest('POST', '/api/addBatches', requestData, {
                    headers: { 'Content-Type': 'application/json' }
                });

                if (response.status !== 'success') {
                    throw new Error(response.message || 'Failed to create batch');
                }

                setBatches([...batches, response.data]);
                setNewBatch({ batch_name: '', start_date: '', end_date: '', enrollment: 0, location: '', status: '', course: '', course_id: '' });
                setCreateBatchAssessments([]);
                setTabValue(1);
                toast.success("Batch created successfully");
            } catch (error) {
                console.error('Error creating batch:', error);
                setError(error.message);
            }
        }
    };

    const exportBatchesToExcel = (batches) => {
        const formattedData = batches.map(batch => ({
            ID: batch.id,
            "Batch Name": batch.batch_name,
            "Start Date": batch.start_date,
            "End Date": batch.end_date,
            Enrollment: batch.enrollment,
            Location: batch.location,
            Status: batch.status,
        }));
        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Batches');
        XLSX.writeFile(workbook, 'batches.xlsx');
    };

    const downloadBatchesAsPDF = (batches) => {
        const doc = new jsPDF();
        doc.setFontSize(16);
        doc.text('Batch Report', 14, 20);

        const columns = [
            { header: 'ID', dataKey: 'id' },
            { header: 'Batch Name', dataKey: 'batch_name' },
            { header: 'Start Date', dataKey: 'start_date' },
            { header: 'End Date', dataKey: 'end_date' },
            { header: 'Enrollment', dataKey: 'enrollment' },
            { header: 'Location', dataKey: 'location' },
            { header: 'Status', dataKey: 'status' },
        ];

        const rows = batches.map(batch => ({
            id: batch.id,
            batch_name: batch.batch_name,
            start_date: batch.start_date,
            end_date: batch.end_date,
            enrollment: batch.enrollment,
            location: batch.location,
            status: batch.status,
        }));
        doc.autoTable({
            columns,
            body: rows,
            startY: 30,
            theme: 'striped',
        });

        doc.save('batches.pdf');
    };

    const openEditModal = (batch) => {
        setSelectedBatch(batch);
        setEditForm({
            batch_name: batch.batch_name || '',
            start_date: batch.start_date || '',
            end_date: batch.end_date || '',
            location: batch.location || '',
            status: batch.status || '',
            course: batch.course || '',
            course_id: batch.course_id || '',
            mode: batch.mode || 'Offline'
        });
        setEditModalOpen(true);
    };

    const closeEditModal = () => {
        setEditModalOpen(false);
        setSelectedBatch(null);
        setEditForm({
            batch_name: '',
            start_date: '',
            end_date: '',
            location: '',
            status: '',
            course: '',
            course_id: '',
            mode: 'Offline'
        });
    };
    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const filteredBatches = batches
        .filter((batch) => {
            const batchName = batch.batch_name?.toLowerCase() || '';
            const course = batch.course?.toLowerCase() || '';
            const location = getLocationName(batch.location).toLowerCase();
            const term = searchTerm.toLowerCase();

            const locationMatch = selectedLocation === 0 || batch.location === selectedLocation;

            const statusMatch = 
                listStatusTab === 3 || 
                (listStatusTab === 0 && batch.status === 'Current') ||
                (listStatusTab === 1 && batch.status === 'Upcoming') ||
                (listStatusTab === 2 && batch.status === 'Completed');

            return locationMatch && statusMatch && (
                batchName.includes(term) ||
                course.includes(term) ||
                location.includes(term)
            );
        })
        .sort((a, b) => b.id - a.id);

    const updateStatus = async () => {
        try {
            if (control == 1 || control == 4) {
                const response = await makeApiRequest('POST', '/api/edit-requests/save', {
                    token: token,
                    module: 'batch_profile',
                    reference_id: selectedBatch.id,
                    old_data: selectedBatch,
                    new_data: editForm
                });
                if (response.status === 'success') {
                    toast.success("Edit request submitted successfully and is pending admin approval.");
                    closeEditModal();
                } else {
                    toast.error(response.message || "Failed to submit edit request");
                }
                return;
            }

            const response = await makeApiRequest('POST', '/api/batch/update/status', {
                token: token,
                data: {
                    id: selectedBatch.id,
                    ...editForm
                }
            });
            if (response.status === 'success') {
                toast.success("Batch updated successfully");
                setBatches(batches.map(batch => batch.id === selectedBatch.id ? { ...batch, ...editForm } : batch));
                closeEditModal();
            }
        } catch (error) {
            toast.error("Failed to update batch");
        }
    };

    const getStatusBadge = (status) => {
        let backgroundColor = '#d1d5db'; // default gray
        let textColor = '#374151'; // default dark gray

        if (status === 'Current') {
            backgroundColor = '#dcfce7'; // light green
            textColor = '#166534'; // dark green
        } else if (status === 'Upcoming') {
            backgroundColor = '#dbeafe'; // light blue
            textColor = '#1e3a8a'; // dark blue
        } else if (status === 'Completed') {
            backgroundColor = '#fef9c3'; // light yellow
            textColor = '#92400e'; // dark yellow/brown
        }

        return (
            <Box
                sx={{
                    display: 'inline-block',
                    padding: '2px 8px',
                    borderRadius: '12px',
                    backgroundColor: backgroundColor,
                    color: textColor,
                    fontSize: '12px',
                    fontWeight: 600,
                    textAlign: 'center',
                    minWidth: '80px',
                }}
            >
                {status}
            </Box>
        );
    };



    return (
        <div style={{ maxWidth: '100%', margin: 'auto', padding: '16px', backgroundColor: "#ECEDFF", fontFamily: "Roboto", minHeight: "100vh" }}>
            <ToastContainer
                position="top-center"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />
            {canManageBatch && (
                <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                    <Tabs value={tabValue} onChange={handleTabChange} aria-label="batch tabs" sx={{
                        '& .MuiTab-root': {
                            color: '#481E82',
                            fontWeight: '600',
                        },
                        '& .Mui-selected': {
                            color: '#481E82 !important',
                        },
                        '& .MuiTabs-indicator': {
                            backgroundColor: '#481E82',
                        }
                    }}>
                        <Tab label="Create New Batch" />
                        <Tab label="Batch List" />
                    </Tabs>
                </Box>
            )}

            {canManageBatch && tabValue === 0 && (
                <>
                    <Box sx={{ height: "50px", display: "flex", alignItems: "center", backgroundColor: "#ECEDFF" }}>
                        <Typography variant="h4" sx={{ color: "#481E82", fontWeight: "500" }}>Create New Batch</Typography>
                    </Box>

                    <Card sx={{ marginTop: "1px", marginBottom: "1px" }}>
                        <CardContent>
                            <Grid container spacing={2} >
                                <Grid item xs={6} sm={3} lg={4}>
                                    <TextField
                                        required
                                        label="Location"
                                        name="location"
                                        fullWidth
                                        size='small'
                                        margin="normal"
                                        select
                                        disabled={control == 4}
                                        value={newBatch.location}
                                        onChange={(e) => {
                                            const selectedLocation = e.target.value;
                                            let prefix = "";
                                            if (selectedLocation === "1") {
                                                prefix = "CH";
                                            } else if (selectedLocation === "2") {
                                                prefix = "TR";
                                            }
                                            const existingName = newBatch.batch_name.replace(/^(CH-|TR-)/, '');
                                            setNewBatch({ ...newBatch, location: selectedLocation, batch_name: `${prefix}-${existingName}` });
                                        }}
                                        InputLabelProps={{ shrink: true }}
                                        sx={{
                                            '& .MuiFormLabel-asterisk': {
                                                color: 'red',
                                            },
                                        }}
                                    >
                                        <MenuItem value="1">Chennai</MenuItem>
                                        <MenuItem value="2">Trichy</MenuItem>
                                    </TextField>


                                </Grid>
                                <Grid item xs={12} sm={3} lg={4}>
                                    <TextField
                                        required
                                        label="Batch Name"
                                        fullWidth
                                        size='small'
                                        margin="normal"
                                        value={newBatch.batch_name}
                                        onChange={(e) => setNewBatch({ ...newBatch, batch_name: e.target.value })}
                                        sx={{
                                            '& .MuiFormLabel-asterisk': {
                                                color: 'red',
                                            },
                                        }}
                                    />


                                </Grid>
                                <Grid item xs={12} sm={3} lg={4}>
                                    <TextField
                                        required
                                        label="Status"
                                        fullWidth
                                        size='small'
                                        select
                                        margin="normal"
                                        value={newBatch.status}
                                        onChange={(e) => setNewBatch({ ...newBatch, status: e.target.value })}
                                        InputLabelProps={{ shrink: true }}
                                        sx={{
                                            '& .MuiFormLabel-asterisk': {
                                                color: 'red',
                                            },
                                        }}
                                    >
                                        <MenuItem value="Current">Current</MenuItem>
                                        <MenuItem value="Upcoming">Upcoming</MenuItem>
                                        <MenuItem value="Completed">Completed</MenuItem>
                                    </TextField>
                                </Grid>
                                <Grid item xs={12} sm={3} lg={4}>
                                    <TextField
                                        required
                                        label="Course"
                                        fullWidth
                                        size="small"
                                        margin='normal'
                                        select
                                        value={newBatch.course}
                                        onChange={(e) => {
                                            const selectedCourseName = e.target.value;
                                            const selectedCourse = courseList.find(course => course.course_name === selectedCourseName);
                                            setNewBatch({
                                                ...newBatch,
                                                course: selectedCourseName,
                                                course_id: selectedCourse ? selectedCourse.id : ''
                                            });
                                        }}
                                        // onClick={fetchCourseData}
                                        InputLabelProps={{ shrink: true }}
                                        sx={{
                                            '& .MuiFormLabel-asterisk': {
                                                color: 'red',
                                            },
                                        }}>
                                        {courseList.length > 0 ? (
                                            courseList.filter(course => course.id > 0)
                                                .map((course) => (
                                                    <MenuItem key={course.id} value={course.course_name}>
                                                        {course.course_name}
                                                    </MenuItem>
                                                ))
                                        ) : (
                                            <MenuItem disabled> -- </MenuItem>
                                        )}
                                    </TextField>
                                </Grid>
                                <Grid item xs={12} sm={3} lg={4}>
                                    <TextField
                                        required
                                        label="Start Date"
                                        type="date"
                                        fullWidth
                                        size='small'
                                        margin="normal"
                                        value={newBatch.start_date}
                                        onChange={(e) => setNewBatch({ ...newBatch, start_date: e.target.value })}
                                        onFocus={(e) => e.target.showPicker()}
                                        InputLabelProps={{ shrink: true }}
                                        // sx={{ width: "25%" }}
                                        sx={{
                                            '& .MuiFormLabel-asterisk': {
                                                color: 'red',
                                            },
                                            "& input": {
                                                color: newBatch.start_date ? "#000" : "#a2a2a2", // Black when date is selected, Gray otherwise
                                            },
                                            "& input::-webkit-datetime-edit-text": {
                                                color: "#a2a2a2", // Ensures "dd-mm-yyyy" placeholder is gray
                                            },
                                            "& input::-webkit-datetime-edit-year-field, \
                                               & input::-webkit-datetime-edit-month-field, \
                                               & input::-webkit-datetime-edit-day-field": {
                                                color: newBatch.start_date ? "#000" : "#a2a2a2", // Black when selected, Gray when empty
                                            }
                                        }}
                                    />

                                </Grid>
                                <Grid item xs={12} sm={3} lg={4}>
                                    <TextField
                                        required
                                        label="End Date"
                                        type="date"
                                        fullWidth
                                        size='small'
                                        margin="normal"
                                        value={newBatch.end_date}
                                        onChange={(e) => setNewBatch({ ...newBatch, end_date: e.target.value })}
                                        onFocus={(e) => e.target.showPicker()}
                                        InputLabelProps={{ shrink: true }}
                                        // sx={{ width: "25%" }}
                                        sx={{
                                            '& .MuiFormLabel-asterisk': {
                                                color: 'red',
                                            },
                                            "& input": {
                                                color: newBatch.end_date ? "#000" : "#a2a2a2", // Black when date is selected, Gray otherwise
                                            },
                                            "& input::-webkit-datetime-edit-text": {
                                                color: "#a2a2a2", // Ensures "dd-mm-yyyy" placeholder is gray
                                            },
                                            "& input::-webkit-datetime-edit-year-field, \
                                               & input::-webkit-datetime-edit-month-field, \
                                               & input::-webkit-datetime-edit-day-field": {
                                                color: newBatch.end_date ? "#000" : "#a2a2a2", // Black when selected, Gray when empty
                                            }
                                        }}
                                    />

                                </Grid>
                                <Grid item xs={12} sm={3} lg={4}>
                                    <TextField
                                        required
                                        label="Employee Mode"
                                        fullWidth
                                        size='small'
                                        select
                                        margin="normal"
                                        value={newBatch.mode}
                                        onChange={(e) => setNewBatch({ ...newBatch, mode: e.target.value })}
                                        InputLabelProps={{ shrink: true }}
                                        sx={{
                                            '& .MuiFormLabel-asterisk': {
                                                color: 'red',
                                            },
                                        }}
                                    >
                                        <MenuItem value="Offline">Offline</MenuItem>
                                        <MenuItem value="Online">Online</MenuItem>
                                    </TextField>
                                </Grid>
                                {createBatchAssessments.length > 0 && (
                                    <Grid item xs={12}>
                                        <Accordion sx={{ mb: 2 }}>
                                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                <Typography sx={{ fontWeight: 600 }}>Configure Assessments (Optional)</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <TableContainer component={Paper} variant="outlined">
                                                    <Table size="small">
                                                        <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                                                            <TableRow>
                                                                <TableCell sx={{ fontWeight: 600 }}>Assessment Component</TableCell>
                                                                <TableCell align="center" sx={{ fontWeight: 600 }}>Enable / Disable</TableCell>
                                                                <TableCell sx={{ fontWeight: 600 }}>Display Name (Screen Label)</TableCell>
                                                                <TableCell align="center" sx={{ fontWeight: 600 }}>Action</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {createBatchAssessments.map((asm, idx) => (
                                                                <TableRow key={asm.generic_name}>
                                                                    <TableCell sx={{ fontWeight: 500 }}>
                                                                        {asm.isNew ? (
                                                                            <TextField
                                                                                select
                                                                                size="small"
                                                                                fullWidth
                                                                                value={asm.generic_name}
                                                                                onChange={(e) => {
                                                                                    const selectedGen = e.target.value;
                                                                                    const compInfo = ALL_ASSESSMENT_COMPONENTS.find(c => c.generic_name === selectedGen);
                                                                                    const updated = [...createBatchAssessments];
                                                                                    updated[idx].generic_name = selectedGen;
                                                                                    updated[idx].specific_name = compInfo ? compInfo.default_specific_name : '';
                                                                                    setCreateBatchAssessments(updated);
                                                                                }}
                                                                            >
                                                                                {[asm, ...getAvailableComponents(createBatchAssessments)].map(comp => (
                                                                                    <MenuItem key={comp.generic_name} value={comp.generic_name}>
                                                                                        {comp.generic_name}
                                                                                    </MenuItem>
                                                                                ))}
                                                                            </TextField>
                                                                        ) : (
                                                                            asm.generic_name
                                                                        )}
                                                                    </TableCell>
                                                                    <TableCell align="center">
                                                                        <Checkbox
                                                                            checked={asm.is_enabled}
                                                                            onChange={(e) => {
                                                                                const updated = [...createBatchAssessments];
                                                                                updated[idx].is_enabled = e.target.checked;
                                                                                setCreateBatchAssessments(updated);
                                                                            }}
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell sx={{ width: '50%' }}>
                                                                        <TextField
                                                                            fullWidth
                                                                            size="small"
                                                                            placeholder="Enter custom display name"
                                                                            value={asm.specific_name}
                                                                            onChange={(e) => {
                                                                                const updated = [...createBatchAssessments];
                                                                                updated[idx].specific_name = e.target.value;
                                                                                setCreateBatchAssessments(updated);
                                                                            }}
                                                                            disabled={!asm.is_enabled}
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell align="center">
                                                                        <IconButton
                                                                            color="error"
                                                                            size="small"
                                                                            onClick={() => {
                                                                                const updated = createBatchAssessments.filter((_, i) => i !== idx);
                                                                                setCreateBatchAssessments(updated);
                                                                            }}
                                                                        >
                                                                            <DeleteIcon />
                                                                        </IconButton>
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                                {createBatchAssessments.length < 5 && getAvailableComponents(createBatchAssessments).length > 0 && (
                                                    <Box sx={{ display: 'flex', justifyContent: 'flex-start', mt: 2 }}>
                                                        <Button
                                                            variant="outlined"
                                                            color="primary"
                                                            size="small"
                                                            onClick={() => {
                                                                const available = getAvailableComponents(createBatchAssessments);
                                                                if (available.length > 0) {
                                                                    setCreateBatchAssessments([
                                                                        ...createBatchAssessments,
                                                                        {
                                                                            generic_name: available[0].generic_name,
                                                                            specific_name: available[0].default_specific_name,
                                                                            is_enabled: true,
                                                                            isNew: true
                                                                        }
                                                                    ]);
                                                                }
                                                            }}
                                                        >
                                                            Add Component
                                                        </Button>
                                                    </Box>
                                                )}
                                            </AccordionDetails>
                                        </Accordion>
                                    </Grid>
                                )}
                                <Grid item xs={12} sm={6} lg={4} sx={{ display: "flex", alignItems: "end", justifyContent: "flex-start" }}>
                                    <CardActions sx={{ paddingRight: 0 }}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={handleCreateBatch}
                                            disabled={!newBatch.location || !newBatch.batch_name || !newBatch.status || !newBatch.course_id || !newBatch.start_date || !newBatch.end_date}
                                        >
                                            Create Batch
                                        </Button>
                                    </CardActions>

                                </Grid>


                            </Grid>

                        </CardContent>

                    </Card>
                </>
            )}

            {(!canManageBatch || tabValue === 1) && (
                <>
                    <Box sx={{ height: "100px", display: "flex", alignItems: "center", backgroundColor: "#ECEDFF", justifyContent: "space-between" }}>
                        <Typography variant="h4" sx={{ color: "#481E82", fontWeight: "500" }}>Batch List</Typography>
                        <Box sx={{ display: "flex", justifyContent: 'space-between', alignItems: "center" }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mr: '10px' }}>
                                {control == 1 && (
                                    <TextField
                                        size="small"
                                        label="Location"
                                        variant="outlined"
                                        select
                                        value={selectedLocation}
                                        onChange={(e) => setSelectedLocation(Number(e.target.value))}
                                        sx={{ fontFamily: 'sans-serif', backgroundColor: 'white', width: '100%' }}
                                        InputLabelProps={{ shrink: true }}
                                    >
                                        <MenuItem value="0">All Location</MenuItem>
                                        <MenuItem value="1">Chennai</MenuItem>
                                        <MenuItem value="2">Trichy</MenuItem>
                                    </TextField>
                                )}
                                <TextField
                                    variant="outlined"
                                    placeholder='Search'
                                    size="small"
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                    sx={{
                                        ml: 2,
                                        backgroundColor: "white",
                                        width: '100%'
                                    }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Search />
                                            </InputAdornment>
                                        ),
                                    }}
                                />

                            </Box>

                            <Box sx={{ display: 'flex' }}>
                                <Button
                                    variant="contained" color="primary"
                                    startIcon={<GridOnIcon />}
                                    disabled={!filteredBatches.length}
                                    sx={{
                                        backgroundColor: "orange",
                                        width: { xs: "100%", sm: "fit-content" },
                                        marginRight: { xs: 0, sm: 2 }
                                    }}
                                    onClick={() => downloadBatchesAsPDF(filteredBatches)}
                                >
                                    Download as PDF
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={() => exportBatchesToExcel(filteredBatches)}
                                    startIcon={<GridOnIcon />}
                                    disabled={!filteredBatches.length}

                                    sx={{
                                        backgroundColor: "#4CAF50",
                                        "&:hover": { backgroundColor: "#45A049" },
                                        width: { xs: "100%", sm: "fit-content" },
                                        marginTop: { xs: 1, sm: 0 }
                                    }}
                                >
                                    Export to EXCEL
                                </Button>

                            </Box>

                        </Box>
                    </Box>

                    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                        <Tabs value={listStatusTab} onChange={handleListStatusTabChange} aria-label="batch status tabs" sx={{
                            '& .MuiTab-root': {
                                color: '#481E82',
                                fontWeight: '600',
                            },
                            '& .Mui-selected': {
                                color: '#481E82 !important',
                            },
                            '& .MuiTabs-indicator': {
                                backgroundColor: '#481E82',
                            }
                        }}>
                            <Tab label="Current" />
                            <Tab label="Upcoming" />
                            <Tab label="Completed" />
                            <Tab label="All" />
                        </Tabs>
                    </Box>

                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow sx={{ backgroundColor: "#f1f4f9" }}>
                                    <TableCell><strong>S.No</strong></TableCell>
                                    <TableCell><strong>Batch Name</strong></TableCell>
                                    <TableCell><strong>Course</strong></TableCell>
                                    <TableCell><strong>Start Date</strong></TableCell>
                                    <TableCell><strong>End Date</strong></TableCell>
                                    <TableCell><strong>Current Enrollment</strong></TableCell>
                                    <TableCell><strong>Employee Mode</strong></TableCell>
                                    <TableCell><strong>Location</strong></TableCell>
                                    <TableCell><strong>Status</strong></TableCell>
                                     {(control == 1 || control == 4) && (
                                         <TableCell><strong>Actions</strong></TableCell>
                                     )}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredBatches
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((batch, index) => (
                                        <TableRow key={batch.id}>
                                            <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                                            <TableCell>{batch.batch_name}</TableCell>
                                            <TableCell><OverflowTooltip>{batch?.course || "N/A"}</OverflowTooltip></TableCell>
                                            <TableCell>{formatDate(batch.start_date)}</TableCell>
                                            <TableCell>{formatDate(batch.end_date)}</TableCell>
                                            <TableCell >{batch.enrollment}</TableCell>
                                            <TableCell>{batch.mode || 'Offline'}</TableCell>
                                            <TableCell>{batch.location == 1 ? 'Chennai' : batch.location == 2 ? 'Trichy' : 'NA'}</TableCell>
                                            <TableCell>{getStatusBadge(batch.status)}</TableCell>
                                             {(control == 1 || control == 4) && (
                                                 <TableCell>
                                                     <IconButton onClick={() => openEditModal(batch)}>
                                                         <EditIcon color="primary" />
                                                     </IconButton>
                                                     <IconButton onClick={() => openAssessmentModal(batch)}>
                                                         <AssignmentIcon color="secondary" />
                                                     </IconButton>
                                                 </TableCell>
                                             )}

                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={filteredBatches.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </TableContainer>
                </>
            )}

            {loading && <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="400px"
            >
                <CircularProgress
                    size={40}
                    thickness={4}
                    sx={{
                        color: '#481E82',
                    }}
                />
            </Box>}
            {error && <Typography variant="body2" color="error">{error}</Typography>}
            <Modal open={editModalOpen} onClose={closeEditModal}>
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 450,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    maxHeight: '90vh',
                    overflowY: 'auto'
                }}>
                    <Typography variant="h6" sx={{ mb: 2 }}>Edit Batch</Typography>
                    <TextField
                        required
                        label="Location"
                        name="location"
                        fullWidth
                        size='small'
                        margin="normal"
                        select
                        disabled={control == 4}
                        value={editForm.location}
                        onChange={(e) => {
                            const selectedLocation = e.target.value;
                            let prefix = "";
                            if (selectedLocation === "1") {
                                prefix = "CH";
                            } else if (selectedLocation === "2") {
                                prefix = "TR";
                            }
                            const existingName = editForm.batch_name.replace(/^(CH-|TR-)/, '');
                            setEditForm({ ...editForm, location: selectedLocation, batch_name: `${prefix}-${existingName}` });
                        }}
                        InputLabelProps={{ shrink: true }}
                    >
                        <MenuItem value="1">Chennai</MenuItem>
                        <MenuItem value="2">Trichy</MenuItem>
                    </TextField>

                    <TextField
                        required
                        label="Batch Name"
                        fullWidth
                        size='small'
                        margin="normal"
                        value={editForm.batch_name}
                        onChange={(e) => setEditForm({ ...editForm, batch_name: e.target.value })}
                    />

                    <TextField
                        required
                        label="Course"
                        fullWidth
                        size="small"
                        margin='normal'
                        select
                        value={editForm.course}
                        onChange={(e) => {
                            const selectedCourseName = e.target.value;
                            const selectedCourse = courseList.find(course => course.course_name === selectedCourseName);
                            setEditForm({
                                ...editForm,
                                course: selectedCourseName,
                                course_id: selectedCourse ? selectedCourse.id : ''
                            });
                        }}
                        InputLabelProps={{ shrink: true }}
                    >
                        {courseList.length > 0 ? (
                            courseList.filter(course => course.id > 0)
                                .map((course) => (
                                    <MenuItem key={course.id} value={course.course_name}>
                                        {course.course_name}
                                    </MenuItem>
                                ))
                        ) : (
                            <MenuItem disabled> -- </MenuItem>
                        )}
                    </TextField>

                    <TextField
                        required
                        label="Start Date"
                        type="date"
                        fullWidth
                        size='small'
                        margin="normal"
                        value={editForm.start_date}
                        onChange={(e) => setEditForm({ ...editForm, start_date: e.target.value })}
                        onFocus={(e) => e.target.showPicker()}
                        InputLabelProps={{ shrink: true }}
                    />

                    <TextField
                        required
                        label="End Date"
                        type="date"
                        fullWidth
                        size='small'
                        margin="normal"
                        value={editForm.end_date}
                        onChange={(e) => setEditForm({ ...editForm, end_date: e.target.value })}
                        onFocus={(e) => e.target.showPicker()}
                        InputLabelProps={{ shrink: true }}
                    />

                    <TextField
                        select
                        fullWidth
                        label="Status"
                        value={editForm.status}
                        onChange={(e) => setEditForm({ ...editForm, status: e.target.value })}
                        margin="normal"
                        size='small'
                    >
                        <MenuItem value="Current">Current</MenuItem>
                        <MenuItem value="Upcoming">Upcoming</MenuItem>
                        <MenuItem value="Completed">Completed</MenuItem>
                    </TextField>

                    <TextField
                        select
                        fullWidth
                        label="Employee Mode"
                        value={editForm.mode}
                        onChange={(e) => setEditForm({ ...editForm, mode: e.target.value })}
                        margin="normal"
                        size='small'
                    >
                        <MenuItem value="Offline">Offline</MenuItem>
                        <MenuItem value="Online">Online</MenuItem>
                    </TextField>

                    <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
                        <Button variant="contained" sx={{ backgroundColor: "rgb(249, 90, 90)", color: '#fff' }} onClick={closeEditModal}>Cancel</Button>
                        <Button variant="contained" color="primary" onClick={updateStatus} disabled={!editForm.location || !editForm.batch_name || !editForm.status || !editForm.course_id || !editForm.start_date || !editForm.end_date || !editForm.mode}>Edit</Button>
                    </Box>
                </Box>
            </Modal>
            <Modal open={assessmentModalOpen} onClose={() => setAssessmentModalOpen(false)}>
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 500,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    maxHeight: '80vh',
                    overflowY: 'auto'
                }}>
                    <Typography variant="h6" sx={{ mb: 2 }}>Configure Assessments for {modalBatch?.batch_name}</Typography>
                    {modalAssessments.length === 0 ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                            <CircularProgress size={30} />
                        </Box>
                    ) : (
                        <>
                            <TableContainer component={Paper} variant="outlined" sx={{ mt: 2 }}>
                                <Table size="small">
                                    <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 600 }}>Assessment Component</TableCell>
                                            <TableCell align="center" sx={{ fontWeight: 600 }}>Enable / Disable</TableCell>
                                            <TableCell sx={{ fontWeight: 600 }}>Display Name (Screen Label)</TableCell>
                                            <TableCell align="center" sx={{ fontWeight: 600 }}>Action</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {modalAssessments.map((asm, idx) => (
                                            <TableRow key={asm.generic_name}>
                                                <TableCell sx={{ fontWeight: 500 }}>
                                                    {asm.isNew ? (
                                                        <TextField
                                                            select
                                                            size="small"
                                                            fullWidth
                                                            value={asm.generic_name}
                                                            onChange={(e) => {
                                                                const selectedGen = e.target.value;
                                                                const compInfo = ALL_ASSESSMENT_COMPONENTS.find(c => c.generic_name === selectedGen);
                                                                const updated = [...modalAssessments];
                                                                updated[idx].generic_name = selectedGen;
                                                                updated[idx].specific_name = compInfo ? compInfo.default_specific_name : '';
                                                                setModalAssessments(updated);
                                                            }}
                                                        >
                                                            {[asm, ...getAvailableComponents(modalAssessments)].map(comp => (
                                                                <MenuItem key={comp.generic_name} value={comp.generic_name}>
                                                                    {comp.generic_name}
                                                                </MenuItem>
                                                            ))}
                                                        </TextField>
                                                    ) : (
                                                        asm.generic_name
                                                    )}
                                                </TableCell>
                                                <TableCell align="center">
                                                    <Checkbox
                                                        checked={asm.is_enabled}
                                                        onChange={(e) => {
                                                            const updated = [...modalAssessments];
                                                            updated[idx].is_enabled = e.target.checked;
                                                            setModalAssessments(updated);
                                                        }}
                                                    />
                                                </TableCell>
                                                <TableCell sx={{ width: '50%' }}>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        placeholder="Enter custom display name"
                                                        value={asm.specific_name}
                                                        onChange={(e) => {
                                                            const updated = [...modalAssessments];
                                                            updated[idx].specific_name = e.target.value;
                                                            setModalAssessments(updated);
                                                        }}
                                                        disabled={!asm.is_enabled}
                                                    />
                                                </TableCell>
                                                <TableCell align="center">
                                                    <IconButton
                                                        color="error"
                                                        size="small"
                                                        onClick={() => {
                                                            const updated = modalAssessments.filter((_, i) => i !== idx);
                                                            setModalAssessments(updated);
                                                        }}
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            {modalAssessments.length < 5 && getAvailableComponents(modalAssessments).length > 0 && (
                                <Box sx={{ display: 'flex', justifyContent: 'flex-start', mt: 2 }}>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        size="small"
                                        onClick={() => {
                                            const available = getAvailableComponents(modalAssessments);
                                            if (available.length > 0) {
                                                setModalAssessments([
                                                    ...modalAssessments,
                                                    {
                                                        generic_name: available[0].generic_name,
                                                        specific_name: available[0].default_specific_name,
                                                        is_enabled: true,
                                                        isNew: true
                                                    }
                                                ]);
                                            }
                                        }}
                                    >
                                        Add Component
                                    </Button>
                                </Box>
                            )}
                        </>
                    )}
                    <Box display="flex" justifyContent="flex-end" gap={2} mt={3}>
                        <Button variant="contained" sx={{ backgroundColor: "rgb(249, 90, 90)", color: '#fff' }} onClick={() => setAssessmentModalOpen(false)}>Cancel</Button>
                        <Button variant="contained" color="primary" onClick={handleSaveBatchAssessments} disabled={isSavingAssessments || modalAssessments.length === 0}>
                            {isSavingAssessments ? 'Submitting...' : 'Submit Request'}
                        </Button>
                    </Box>
                </Box>
            </Modal>
            <Dialog open={confirmOpen} onClose={() => { setConfirmOpen(false); setIsSavingAssessments(false); }} maxWidth="xs" fullWidth>
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, color: confirmSeverity === 'danger' ? '#d32f2f' : '#1976d2' }}>
                    {confirmSeverity === 'danger' ? <WarningIcon color="error" /> : <InfoIcon color="primary" />}
                    {confirmTitle}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>{confirmMessage}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setConfirmOpen(false); setIsSavingAssessments(false); }} color="inherit">Cancel</Button>
                    <Button onClick={submitAssessmentsUpdate} color={confirmSeverity === 'danger' ? 'error' : 'primary'} variant="contained">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
export default AddBatch;